import { Button } from 'lego-on-react';
import React, { useCallback, useState } from 'react';

import i18n from '@yandex-int/i18n';
import * as keyset from 'i18n/DraftControlPanel';
import block from 'propmods';

import { DevicesTestingFormSettings } from '../../../model/devicesTestingForm';
import { TestingDateSelectionForm } from '../TestingDateSelectionForm/TestingDateSelectionForm';

import './TestingDateSelectionChanger.scss';

const b = block('TestingDateSelectionChanger');
const t = i18n(keyset);

interface Props {
    beforeButtonElement?: React.ReactNode;
    afterButtonElement?: React.ReactNode;
    formSettings: DevicesTestingFormSettings;
    afterFormSave: () => Promise<void>;
    disabled: boolean;
}

export const TestingDateSelectionChanger: React.FC<Props> = ({
    afterButtonElement,
    beforeButtonElement,
    formSettings,
    afterFormSave,
    disabled,
}) => {
    const [displayForm, setDisplayForm] = useState(false);

    const hideForm = useCallback(() => {
        setDisplayForm(false);
    }, []);

    const showForm = useCallback(() => {
        setDisplayForm(true);
    }, []);

    const afterSave = useCallback(async () => {
        await afterFormSave();
        hideForm();
    }, [hideForm, afterFormSave]);

    return (
        <div {...b()}>
            {displayForm ? (
                <TestingDateSelectionForm
                    onCancel={hideForm}
                    initialSettings={formSettings}
                    afterSave={afterSave}
                    disabled={disabled}
                />
            ) : (
                <>
                    {beforeButtonElement && <div {...b('before')}>{beforeButtonElement}</div>}
                    <div {...b('button')}>
                        <Button size="s" theme="normal" onClick={showForm} disabled={disabled}>
                            {t('button-change-date')}
                        </Button>
                    </div>
                    {afterButtonElement && <div {...b('after')}>{afterButtonElement}</div>}
                </>
            )}
        </div>
    );
};
